import {getUserType} from "./authenticator";
import moment from "moment";
import $ from "jquery";


const isEmpty = (obj) => {
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop))
      return false;
  }
  return true;
};

export const getMinutesToHours = (minutes) => {
  let getHours = Math.floor((minutes / 60))
  let getMinutes = (minutes % 60)

  if (!(getHours === 0)) {
    return getHours + " hr(s) " + getMinutes + ""
  }
  return getMinutes + ""
}

export const phoneNumberRegexPattern = () => {
  return /[025]{1}\d{8}/
}

const deliveryStatesKeys = ["pending", "pick_up", "pickup_complete", "drop_off", "delivered", "completed"];
const deliveryStates = ["Pending", "Pick Up", "Pickup Complete", "Drop Off", "Delivered", "Completed"];

const userAccountMenu = [
  {title: "Account Profile", key: "profile"},
  {title: "API Integration / Webhook", key: "api"}
];

export const dateFormatter = (rawDate) => {
  return moment(rawDate).format('MMMM Do YYYY, h:mm a');
};

const riderAccountMenu = [
  {title: "Account Profile", key: "profile"},
  {title: "Settlement Account", key: "settlement"},
  {title: "Business Information", key: "business"}
];

const courierAccountMenu = [
  {title: "Account Profile", key: "profile"},
  {title: "Settlement Account", key: "settlement"},
  {title: "Business Information", key: "business"}
];

const getCurrentAccountMenu = () => {
  switch (getUserType()) {
    case deliveryType.user:
      return userAccountMenu;
    case deliveryType.courier:
      return courierAccountMenu;
    case deliveryType.rider:
      return riderAccountMenu;
    default:
      return userAccountMenu;
  }
};

const googleAPIKEY = "AIzaSyCcXxaAsCQE24PWqH2pBJhazZrmIEq6hJg";

export const setDataTables = () => {
  $('.table').DataTable();
};

export const googleMapsExternalLink = (origin, destination) => {
  return "https://www.google.com/maps/dir/?api=1&origin=" + origin + "&destination=" + destination + "&travelmode=driving";
};

const displayCurrentDeliveryStatus = (currentStatus) => {
  let index = deliveryStatesKeys.indexOf(currentStatus.toLowerCase());
  if (index >= 0) {
    return deliveryStates[index];
  }
  return "Accept";
};

export const getErrorMessage = (type) => {
  switch (type) {
    case "required" :
      return " This field is required";
    case "minLength":
      return " This field is minLength";
    case "maxLength":
      return " This field is maxLength";
    case "min":
      return " This field is min";
    case "max":
      return " This field is can't be more";
    case "pattern":
      return " Pattern mismatch";
    default:
      return ""
  }
}

const displayNextDeliveryStatus = (currentStatus) => {
  let index = deliveryStatesKeys.indexOf(currentStatus.toLowerCase());
  if (index >= 0) {
    return deliveryStates[index + 1];
  }
  return "Accept";
};

const getNextStatus = (currentStatus) => {
  let index = deliveryStatesKeys.indexOf(currentStatus.toLowerCase());
  if (index >= 0) {
    return deliveryStatesKeys[index + 1];
  }
  return "pending";
};

const generateGoogleStaticMap = (origin, destination) => {
  return "https://maps.googleapis.com/maps/api/staticmap?center=Accra&zoom=12&size=600x350&maptype=roadmap&markers=color:blue|" + origin + "&markers=color:green|" + destination + "\n" +
    "&key=AIzaSyCcXxaAsCQE24PWqH2pBJhazZrmIEq6hJg&path=color:0x0000ff|weight:3|" + origin + "|" + destination + "&scale=1";
};

const phoneNumberValidator = (rawPhone) => {

};


const deliveryType = {
  rider: "rider",
  user: "user",
  courier: "courier"
};


export default {
  isEmpty: isEmpty,
  deliveryType: deliveryType,
  deliveryStatesKeys: deliveryStatesKeys,
  deliveryState: deliveryStates,
  getNextStatus: getNextStatus,
  displayNextDeliveryStatus: displayNextDeliveryStatus,
  displayCurrentDeliveryStatus: displayCurrentDeliveryStatus,
  generateGoogleStaticMap: generateGoogleStaticMap,
  getCurrentAccountMenu: getCurrentAccountMenu
}
